// extracted by mini-css-extract-plugin
export default {"root":"onboarding_header-module___root___a20e4a80","back":"onboarding_header-module___back___dda80374","backIcon":"onboarding_header-module___backIcon___d6555b6a"};